import DeleteWatchListEntryModal from './DeleteWatchListEntryModal';

export default DeleteWatchListEntryModal;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/delete-watch-list-entry-modal/index.js